import React from 'react';
const Critical = () => {
    return (
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.07 89.2" class="h-12 py-1 m-auto"><g id="Ebene_1" data-name="Ebene 1"><path fill="#c05621" d="M96.1,77.3,60.2,11.5A11.59,11.59,0,0,0,49.9,5.4h0a11.59,11.59,0,0,0-10.3,6.1L3.9,77.3a11.71,11.71,0,0,0,.2,11.6,11.54,11.54,0,0,0,10.1,5.7H85.7A11.76,11.76,0,0,0,96.1,77.3ZM45.6,34.5a5.91,5.91,0,0,1,4.3-1.9,5.8,5.8,0,0,1,5.8,5.8v.8l-3,24a8.63,8.63,0,0,0-2.8-.4,8,8,0,0,0-2.7.4l-3-24A6.44,6.44,0,0,1,45.6,34.5Zm4.3,44.6a5.8,5.8,0,1,1,5.8-5.8A5.68,5.68,0,0,1,49.9,79.1Z" transform="translate(-2.46 -5.4)"></path></g></svg>
        </div>
    );
}

export default Critical;